import {getRefinementExpandClass} from '../../../../../helper';

/**
 * @param {import('../../../../../type-definitions').Category} category - category
 * @returns {string} category dropdown HTML
 */
export default category => {
    const categoryLevel = 0;
    const expandClass = getRefinementExpandClass('category');
    return `
        <li class="refinement category refinement-category category-refinement" data-attrid="category">
            <div class="refinement-dropdown">
                <div class="refinement-select toggle ${expandClass}" tabindex="0" role="button"  aria-expanded="false">
                    <div class="refinement-select-inner" aria-label="${window.Resources.SEARCH_REFINEMENT_CATEGORY}"
                        tabindex="0">
                        <input type="hidden" name="filterType" value="${window.Resources.SEARCH_REFINEMENT_CATEGORY.toUpperCase()}"/>
                        <span>${window.Resources.SEARCH_REFINEMENT_CATEGORY}</span>
                        <span class="plus-minus-icon" aria-hidden="true"></span>
                    </div>
                </div>
                <div class="refinement-option-list toggle-content">
                    <div class="dropdown-inner">
                        <ul id="category-level-${categoryLevel}">
                            ${category.children
                                .map(child => {
                                    const categoryLabel = window.Resources.SEARCH_REFINEMENT_TO_CATEGORY.replace(
                                        '{0}',
                                        child.name
                                    );
                                    return `
                                        <li class="expandable">
                                            <a class="refinement-link" href="${child.data.url}" title="${categoryLabel}"
                                                data-gender="${child.data?.gender || ''}">
                                                <span class="text-ctr">
                                                    ${child.name}
                                                </span>
                                            </a>
                                        </li>
                                    `;
                                })
                                .join('')}
                        </ul>
                    </div>
                </div>
            </div>
        </li>
    `;
};
